import { render } from "./InputVideo.vue?vue&type=template&id=db812004&scoped=true"
import script from "./InputVideo.vue?vue&type=script&lang=js"
export * from "./InputVideo.vue?vue&type=script&lang=js"

import "./InputVideo.vue?vue&type=style&index=0&id=db812004&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db812004"]])

export default __exports__